import * as React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import g from 'glamorous'

import LoginForm from './login/LoginForm'
import Headline from '../components/Headline'
import HeaderContainer from '../components/HeaderContainer'
import Loading from '../components/Loading'
import LoginMutation from '../components/mutations/LoginMutation'
import { setToken } from '../utils/auth'
import history from '../history'

export interface LoginProps {}

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto'
  }
})

const Login: React.SFC<LoginProps> = () => {
  return (
    <StyledContainer>
      <HeaderContainer>
        <Headline>Prihlasit se</Headline>
        <ButtonToolbar>
          <LinkContainer to="/forgotten-password">
            <Button>Zapomenuté heslo</Button>
          </LinkContainer>
        </ButtonToolbar>
      </HeaderContainer>
      <LoginMutation>
        {(login, { data, called, error, loading }) => {
          if (loading) {
            return <Loading />
          }

          return (
            <LoginForm
              onSubmit={async ({ email, password }) => {
                const result = await login({ variables: { email, password } })

                if (result == null || result.data == null) {
                  return
                }

                setToken(result.data.login.token)

                history.push('/my-loans')
              }}
            />
          )
        }}
      </LoginMutation>
    </StyledContainer>
  )
}

export default Login



// WEBPACK FOOTER //
// ./src/screens/Login.tsx